export const SimpleTable = ({ data = [] }) => {
  const columns = [...new Set(data.flatMap((row) => Object.keys(row)))];

  return (
    <div className="overflow-hidden rounded-lg border border-perception-black-800">
      <table className="min-w-full divide-y divide-perception-black-800">
        <thead className="bg-perception-gray-900">
        <tr>
          {columns.map((column) => (
            <th
              key={column}
              scope="col"
              className="px-4 py-3 text-left text-sm font-semibold bg-perception-black-800 text-perception-gray-400"
            >
              {column}
            </th>
          ))}
        </tr>
        </thead>
        <tbody className="divide-y divide-perception-black-800">
        {data.map((row, index) => (
          <tr key={row.id ?? row.email ?? index} className="hover:bg-perception-gray-900">
            {columns.map((column) => (
              <td
                key={column}
                className="whitespace-nowrap px-4 py-3 text-sm text-perception-gray-600"
              >
                {row[column] ?? ''}
              </td>
            ))}
          </tr>
        ))}
        </tbody>
      </table>
    </div>
  );
};